import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-terms-privacy-modal',
    templateUrl: './terms-privacy-modal.component.html',
    styleUrls: ['./terms-privacy-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TermsPrivacyModalComponent {
  showTerms = true;
  showNav = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { privacyPolicyContent: SafeHtml, showTerms: boolean, showNav: boolean }) {
    this.showTerms = data?.showTerms ?? true;
    this.showNav = data?.showNav ?? true;
   }
}
